import styled from 'styled-components'

export default styled.h2`
  margin-top: -20px;
  color: hsla(47, 21%, 15%, 0.5);
`
